// extracted by mini-css-extract-plugin
module.exports = {"root":"Tag_oken_root__WrjlJ","default":"Tag_oken_default__1MpXx","primary":"Tag_oken_primary__qWGup","small":"Tag_oken_small__Gk93_"};